<template>
    <div>
        <table class="table table-sm table-bordered table-hover">
            <thead>
            <tr>
                <th :colspan="4 + $root.paymentTypes.length">
                    <span>
                      {{reception}} / {{partnerTourName}} / Долг: -
                    </span>
                    <span class="float-right">
                        <vue-barcode :value="customerBarCode" :width="2" height="20" :margin="0" display-value="false">
                        Ошибка штрихкода
                        </vue-barcode>
                    </span>
                </th>
                <th class="d-print-none" v-if="allowDeleting"></th>
                <th width="20px" class="d-print-none" v-if="allowMarking" title="Доставлено">Д</th>
                <th width="20px" class="d-print-none" v-if="allowMarking" title="Оплачено">О</th>
                <th width="20px" class="d-print-none" v-if="allowMarking" title="Оплачено частично">Ч</th>
                <th width="20px" class="d-print-none" v-if="allowMarking" title="Частичная сумма">ЧС</th>
                <th width="20px" class="d-print-none" v-if="allowMarking" title="Сдано">С</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="item in orders" :class="{'bg-danger': item.isExist}">
                <td width="150">{{item.order.SferaNumber}} {{item.order.LocalNumber && (`/ ${item.order.LocalNumber}`)}}</td>
                <td>{{item.order.Name}}</td>
<!--                <td>{{order.Reception}}</td>-->
                <td width="50">{{item.order.Amount}}</td>
                <td width="70" v-for="paymentType in $root.paymentTypes">{{item.order.PaymentTypeId === paymentType.Id ? item.order.Summary : ''}}</td>
                <td width="170">
                    <vue-barcode :value="item.order.SferaNumber" width="2" height="20" :margin="0" display-value="false">
                        Ошибка штрихкода
                    </vue-barcode>
                </td>
                <td class="d-print-none" v-if="allowDeleting"><a href="#" @click.prevent="$emit('remove', item.order.Id)">Удалить</a></td>
                <th v-if="allowMarking">
                    {{item.order.IsDelivered}}
                    <input type="checkbox" v-model="item.delivery.IsDelivered" @click.prevent="markDeliveries('IsDelivered', item.delivery.IsDelivered, item.delivery.Id)">
                </th>
                <th v-if="allowMarking">
                    <input type="checkbox" v-model="item.delivery.IsPaid" @click.prevent="markDeliveries('IsPaid', item.delivery.IsPaid, item.delivery.Id)">
                </th>
                <th v-if="allowMarking">
                    <input type="checkbox" v-model="item.delivery.IsPartPaid" @click.prevent="markDeliveries('IsPartPaid', item.delivery.IsPartPaid, item.delivery.Id)">
                </th>
                <th width="100" v-if="allowMarking">
                    <input type="number" style="width: auto; max-width: 100px;" class="position-relative w-auto form-control form-control-sm"
                           v-model="item.delivery.PartAmount" @keyup.enter="$emit('part-amount-commit', {DeliveryId: item.delivery.Id, PartAmount: item.delivery.PartAmount})">
                </th>
                <th v-if="allowMarking">
                    <input type="checkbox" v-model="item.delivery.IsPassed" @click.prevent="markDeliveries('IsPassed', item.delivery.IsPassed, item.delivery.DeliveryId)">
                </th>
            </tr>
            </tbody>
        </table>
        <non-delivery :partner-id="partnerId" :exist-order-ids="orderIDs"></non-delivery>
    </div>
</template>
<script>
import VueBarcode from 'vue-barcode';
import _ from 'lodash';
import moment from 'moment';
import NonDelivery from '@/admin/modules/Delivery/_components/NonDelivery.vue';

export default {
  components: { NonDelivery, VueBarcode },
  props: {
    orders: {
      type: Array,
      default() {
        return [];
      },
    },
    allowDeleting: Boolean,
    allowMarking: Boolean,
  },
  data() {
    return {
      allIsDelivered: null,
      allIsPaid: null,
      allIsPassed: null,
      tourSummary: [],
    };
  },
  // mounted() {
  //   const order = _.head(this.orders);
  //   return this.reception = order.Reception;
  // },
  created() {
    this.watchCheckboxes();
  },
  mounted() {
    this.initTourSummary();
  },
  watch: {
    orders: 'watchCheckboxes',
  },
  computed: {
    partnerId() {
      const item = _.head(this.orders);
      return item.customer.Id;
    },
    orderIDs() {
      return _.map(this.orders, 'Id');
    },
    deliveryIDs() {
      return _.map(this.orders, o => o.order.DeliveryId);
    },
    reception() {
      const item = _.head(this.orders);
      return item.customer.Reception;
    },
    partnerTourName() {
      const item = _.head(this.orders);
      return item.tour.Name;
    },
    pointBarCode() {
      const item = _.head(this.orders);
      return `pd_${item.customer.Id}_${moment(String(this.$route.query.time))
        .unix()}`;
    },
  },
  methods: {
    initTourSummary() {
      // if (!this.orders) return;
      //
      // console.log(this.$root.paymentTypes);
      // let tourSummary = Object.assign({}, this.$root.paymentTypes);
      // tourSummary = _.mapKeys(tourSummary, item => item.Id);
      //
      // _.forEach(this.orders, (order) => {
      //   tourSummary[order.order.PaymentTypeId].Summary = +tourSummary[order.order.PaymentTypeId].Summary || 0;
      //   tourSummary[order.order.PaymentTypeId].Summary += +order.order.Summary;
      // console.log('tourSummary', tourSummary[order.order.PaymentTypeId].Summary)
      // });
      // this.$nextTick(() => {
      //   this.$emit('summary-created');
      // });
      // this.tourSummary = tourSummary;
    },
    watchCheckboxes() {
      this.allIsDelivered = _.every(this.orders, o => o.order.IsDelivered);
      this.allIsPaid = _.every(this.orders, o => o.order.IsPaid);
      this.allIsPassed = _.every(this.orders, o => o.order.IsPassed);
    },
    allToDelivered() {
      this.markDeliveries('IsDelivered', this.allIsDelivered);
    },
    allToPaid() {
      this.markDeliveries('IsPaid', this.allIsPaid);
    },
    allToPassed() {
      this.markDeliveries('IsPassed', this.allIsPassed);
    },
    async markDeliveries(PropName, value, id) {
      const IDs = id ? [id] : this.deliveryIDs;
      this.$emit('delivery-checkboxes-changed', {
        PropName,
        DeliveryIDs: IDs,
        value,
      });
      // await this.$nextTick()
      // this.watchCheckboxes();
    },
  },
};
</script>
